module.exports = __webpack_public_path__ + "static/media/static-ca.c78996e9.png";